<aw-section
  testIdAffix="on-demand-journey"
  [isCollapsible]="true">
  <aw-section-header>
    <aw-section-headline size="small">
      <div class="flex">
        <span #headlineText>{{
          cmsTextProvider.configuration.operatorMapping
        }}</span>
      </div>
    </aw-section-headline>
  </aw-section-header>
  @if (!operatorMappingStore.isLoading()) {
    <aw-button
      id="operator-mapping-create"
      type="button"
      (click)="openCreateOperatorMappingDialog()">
      <span class="material-symbols-rounded pr-2">add</span>
      {{ cmsTextProvider.configuration.addOperatorMapping }}
    </aw-button>
    <div
      class="border-standard-outline-light flex flex-col overflow-hidden rounded-lg border-1">
      <div class="bg-standard-surface grid grid-cols-13 gap-2 font-semibold">
        <div class="col-span-2 p-2">
          {{ cmsTextProvider.configuration.onDemandJourneyProvider }}
        </div>
        <div class="col-span-1 px-1 py-2">
          {{ cmsTextProvider.configuration.operatorId }}
        </div>
        <div class="col-span-2 p-2">
          {{ cmsTextProvider.configuration.url }}
        </div>
        <div class="col-span-2 p-2">
          {{ cmsTextProvider.configuration.onDemandSortLabel }}
        </div>
        <div class="col-span-2 p-2">
          {{ cmsTextProvider.configuration.comfortSortLabel }}
        </div>
        <div class="col-span-2 p-2">
          {{ cmsTextProvider.configuration.publicTransportProductGroupLabel }}
        </div>
        <div class="col-span-2 p-2">
          {{ cmsTextProvider.configuration.dropDownOptions }}
        </div>
        <div class="col-span-1 p-2"></div>
      </div>
      @for (operatorMapping of operatorMappingForms.controls; track $index) {
        @let mapping = operatorMapping.value;
        <div
          class="border-standard-outline-light grid grid-cols-13 gap-2 border-t-1">
          <div class="col-span-2 overflow-hidden p-2">{{ mapping.name }}</div>
          <div class="col-span-1 overflow-hidden p-2">
            {{ mapping.operatorId }}
          </div>
          <div class="col-span-2 overflow-hidden p-2">{{ mapping.url }}</div>
          <div class="col-span-2 overflow-hidden p-2">
            {{ getSortName(mapping.onDemandSortExternalRef) }}
          </div>
          <div class="col-span-2 overflow-hidden p-2">
            {{ getSortName(mapping.comfortSortExternalRef) }}
          </div>
          <div class="col-span-2 overflow-hidden p-2">
            {{ mapping.publicTransportProductGroup }}
          </div>
          <div class="col-span-1 overflow-hidden p-2">
            @for (
              option of operatorMapping.controls.dropDownOptions.controls;
              track $index
            ) {
              <div>{{ option.value.name }}</div>
            }
          </div>
          <div class="col-span-1 p-2">
            <span
              class="material-symbols-rounded cursor-pointer"
              [id]="'operator-mapping-' + $index + 'edit'"
              (click)="openEditOperatorMappingDialog(operatorMapping, $index)">
              edit
            </span>
            <span
              class="material-symbols-rounded text-input-error cursor-pointer"
              (click)="openDeleteOperatorMappingDialog(operatorMapping, $index)"
              [id]="'operator-mapping-' + $index + 'delete'">
              delete
            </span>
          </div>
        </div>
      }
    </div>
  } @else {
    <aw-loading-animation></aw-loading-animation>
  }
</aw-section>
